import $ from 'jquery'
import auth from './lib/auth'
import cart from './lib/cart'
import eventListeners from './events/listeners'

const parentClass = 'addiesaas-mini-components'

const domPaths = {
  '#swm-mobi-nav-icon #swm-mobi-nav-btn': 'insertBefore',
  '.swm-main-container .swm-topbar .swm-topbar-content .right': 'insertBefore'
}

const defaultUrls = {
  cart: '/shopping-cart',
  login: '/sign-in',
  profile: '/profile',
}
export const init = (urls = defaultUrls, domTargets = domPaths) => {
  for (let [targetSelector, insertAction] of Object.entries(domTargets)) {
    let parent = $(targetSelector).find(`.${parentClass}`)
    if (!parent.length) {
      parent = $(`<div class="${parentClass}"></div>`)[insertAction](targetSelector)
    }
    // parent.empty()
    ([auth, cart]).forEach(module => {
      const dom = module.init(urls)
      parent.append(dom)
      module.update(dom)
    })
  }
}

export const RocketEffectStylePack = {
  auth,
  cart,
  init
}

init(defaultUrls, domPaths)

window.RocketEffectStylePack = RocketEffectStylePack

export default RocketEffectStylePack
